/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from "react";
import { HiOutlineDocument } from "react-icons/hi";
import { VscFileSubmodule } from "react-icons/vsc";
import { BsBook, BsPeople } from "react-icons/bs";
import { GrAttraction, GrRestaurant } from "react-icons/gr";
import {
  MdOutlineMuseum,
  MdOutlineNightlight,
  MdOutlineHotelClass,
  MdOutlineFoodBank,
  MdOutlineFormatPaint,
  MdOutlineMapsHomeWork,
  MdMusicNote,
} from "react-icons/md";
import { SiHotelsdotcom } from "react-icons/si";
import { AiOutlineShopping } from "react-icons/ai";
import { BiCameraMovie } from "react-icons/bi";
import { GiTheater, GiBallerinaShoes } from "react-icons/gi";
import { Card } from "../../component/Component";
import { useDashboardContext } from "../../../../context/dashboard/context/DashboardContext";
import { TableStatistics } from "../dashboard/DashBoard";
import { pushLevel, setAdminOption } from "../../../../middlewares";
import { addOneLevel } from "../../../../middlewares/breadCrumb/BreadCrumb";
import { useAdminContext } from "../../../../context/admin/context/AdminContext";
import { Link } from "react-router-dom";

const Content = () => {
  const { sysAdmin } = useAdminContext();
  const { stats, fetchData } = useDashboardContext();

  useEffect(() => {
    if (!stats) fetchData();
  }, [stats]);

  const ALL = useMemo(() => {
    const base = [
      { name: "events", quantity: stats ? stats.event : "-", route: "/data/event" },
      { name: "attractions", quantity: stats ? stats.attraction : "-", route: "/data/attraction" },
      { name: "restaurants", quantity: stats ? stats.restaurant : "-", route: "/data/restaurant" },
      { name: "best of africa", quantity: stats ? stats.best_of_africa : "-", route: "/data/bestofafrica" },
      { name: "music", quantity: stats ? stats.music : "-", route: "/data/music" },
      { name: "news", quantity: stats ? stats.news : "-", route: "/data/news" },
      { name: "safaris", quantity: stats ? stats.safari : "-", route: "/data/safari" },
      { name: "tour packages", quantity: stats ? stats.tour_package : "-", route: "/data/tour/package" },
      { name: "cinema", quantity: stats ? stats.cinema : "-", route: "/data/cinema" },
      { name: "museums", quantity: stats ? stats.museum : "-", route: "/data/museum" },
      { name: "night life", quantity: stats ? stats.nightlife : "-", route: "/data/nightlife" },
      { name: "hotels", quantity: stats ? stats.hotel : "-", route: "/data/hotel" },
      { name: "classes", quantity: stats ? stats.class : "-", route: "/data/class" },
      { name: "shopping", quantity: stats ? stats.shopping : "-", route: "/data/shopping" },
      { name: "food", quantity: stats ? stats.food : "-", route: "/data/food" },
      { name: "books", quantity: stats ? stats.book : "-", route: "/data/book" },
      { name: "neighborhoods", quantity: stats ? stats.neighborhood : "-", route: "/data/neighborhood" },
      { name: "arts", quantity: stats ? stats.art : "-", route: "/data/art" },
      { name: "dance", quantity: stats ? stats.dance : "-", route: "/data/dance" },
      { name: "theaters", quantity: stats ? stats.theater : "-", route: "/data/theater" },
      { name: "City Guides", quantity: stats ? stats.city_guide : "-", route: "/data/city/guide" },
      { name: "Parties", quantity: stats ? stats.party : "-", route: "/data/party" },
      { name: "Things To Do", quantity: stats ? stats.things_to_do : "-", route: "/data/things/todo" },
      { name: "Tips And Advice", quantity: stats ? stats.tips_and_advice : "-", route: "/data/tips/advice" },
      { name: "Ministries", quantity: stats ? stats.ministry : "-", route: "/data/ministry" },
      { name: "Movies", quantity: stats ? stats.movie : "-", route: "/data/movie" },
      { name: "Getting Around", quantity: stats ? stats.getting_around : "-", route: "/data/get/around" },
    ];

    const icons = [
      <VscFileSubmodule />,
      <GrAttraction />,
      <GrRestaurant />,
      <MdOutlineHotelClass />,
      <MdMusicNote />,
      <BsBook />,
      <MdOutlineMuseum />,
      <GrAttraction />,
      <BiCameraMovie />,
      <MdOutlineMuseum />,
      <MdOutlineNightlight />,
      <SiHotelsdotcom />,
      <MdOutlineHotelClass />,
      <AiOutlineShopping />,
      <MdOutlineFoodBank />,
      <BsBook />,
      <BsPeople />,
      <MdOutlineFormatPaint />,
      <GiBallerinaShoes />,
      <GiTheater />,
      <GrAttraction />,
      <BsBook />,
      <HiOutlineDocument />,
      <BsBook />,
      <MdOutlineMapsHomeWork />,
      <GiTheater />,
      <MdOutlineMapsHomeWork />,
    ];

    return base.map((item, i) => ({ ...item, icon: icons[i] || null }));
  }, [stats]);

  const pick = (...names) =>
    names.map((n) => ALL.find((i) => i?.name === n)).filter(Boolean);

  const SECTIONS = [
    {
      title: "Explore",
      subtitle: "Experiences and discovery",
      tone: "from-emerald-400/10 via-teal-400/10 to-cyan-400/10",
      items: pick("events", "attractions", "Things To Do", "Parties", "best of africa"),
    },
    {
      title: "Food & Nightlife",
      subtitle: "Where to eat and go out",
      tone: "from-rose-400/10 via-pink-400/10 to-fuchsia-400/10",
      items: pick("restaurants", "food", "night life"),
    },
    {
      title: "Stay & Shop",
      subtitle: "Hotels, deals and essentials",
      tone: "from-amber-400/10 via-orange-400/10 to-yellow-400/10",
      items: pick("hotels", "shopping"),
    },
    {
      title: "Culture & Media",
      subtitle: "Art, performances and stories",
      tone: "from-indigo-400/10 via-violet-400/10 to-purple-400/10",
      items: pick(
        "museums",
        "arts",
        "theaters",
        "dance",
        "music",
        "cinema",
        "Movies",
        "books",
        "news"
      ),
    },
    {
      title: "Guides & Travel",
      subtitle: "Plan and move with confidence",
      tone: "from-sky-400/10 via-blue-400/10 to-indigo-400/10",
      items: pick("City Guides", "safaris", "tour packages", "Getting Around", "neighborhoods"),
    },
    {
      title: "Civic & Advice",
      subtitle: "Official information and tips",
      tone: "from-lime-400/10 via-green-400/10 to-emerald-400/10",
      items: pick("Ministries", "Tips And Advice", "classes"),
    },
  ];

  const handleClick = (card) => {
    if (
      ![
        "regions",
        "countries",
        "First Level",
        "Second Level",
        "Third Level",
        "Fourth Level",
        "tour package",
      ].includes(card?.name)
    ) {
      addOneLevel({
        id: 0,
        name: `${sysAdmin?.first_name} ${sysAdmin?.last_name}`,
        route: "/levels/first",
        level: "",
        country_id: 0,
        data: {
          data: {
            name: "",
            country_id: 0,
            first_level_id: 0,
            second_level_id: 0,
            third_level_id: 0,
            fourth_level_id: 0,
            level: "",
          },
        },
      });
      pushLevel({
        level: {
          id: 0,
          name: "",
          level: "All",
          route: "/levels/first",
          data: null,
        },
      });
      setAdminOption(sysAdmin?.admin_id);
    } else {
      setAdminOption(undefined);
    }
  };

  return (
    <div className="relative h-full overflow-y-auto">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute -top-32 left-1/2 h-64 w-64 -translate-x-1/2 rounded-full bg-emerald-300/10 blur-3xl" />
        <div className="absolute top-20 -left-20 h-72 w-72 rounded-full bg-indigo-300/10 blur-3xl" />
        <div className="absolute bottom-10 -right-10 h-72 w-72 rounded-full bg-amber-300/10 blur-3xl" />
      </div>

      <div className="mx-auto max-w-7xl px-4 py-4 lg:px-6">
        <div className="mb-6 flex items-end justify-between gap-3">
          <div>
            <h1 className="text-xl font-bold tracking-tight text-gray-900">Content Library</h1>
            <p className="mt-1 text-sm text-gray-600">
              Curated modules organized by theme. Click a card to manage content.
            </p>
          </div>
          <div className="flex items-center gap-2">
            <span className="rounded-full bg-white/70 px-3 py-1 text-xs font-semibold text-gray-700 ring-1 ring-gray-200 backdrop-blur">
              {sysAdmin?.first_name ? `Admin: ${sysAdmin.first_name}` : "Admin"}
            </span>
          </div>
        </div>

        <div className="space-y-8">
          {SECTIONS.filter((s) => s.items.length > 0).map((section, idx) => (
            <section key={section.title} aria-label={section.title}>
              <div className="relative">
                <div className={`absolute -inset-1 rounded-3xl bg-gradient-to-r ${section.tone} blur-2xl`} />
                <div className="relative rounded-3xl border border-gray-200 bg-white/80 p-5 shadow-sm backdrop-blur">
                  <div className="mb-4 flex items-center justify-between">
                    <div>
                      <h2 className="text-lg font-semibold tracking-tight text-gray-900">
                        {section.title}
                      </h2>
                      <p className="text-xs text-gray-600">{section.subtitle}</p>
                    </div>
                    <div className="hidden sm:block">
                      <span className="rounded-full bg-gray-100 px-3 py-1 text-[11px] font-semibold text-gray-700">
                        {section.items.reduce((a, c) => a + (Number(c.quantity) || 0), 0).toLocaleString()} items
                      </span>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
                    {section.items.map((card) => (
                      <Link
                        key={card.name}
                        to={card.route}
                        onClick={() => handleClick(card)}
                        className="focus:outline-none"
                      >
                        <Card
                          card={{
                            name: card.name,
                            quantity: card.quantity,
                            icon: card.icon,
                          }}
                        />
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </section>
          ))}

          <section aria-label="Insights">
            <div className="rounded-3xl border border-gray-200 bg-white/80 p-4 shadow-sm backdrop-blur">
              <TableStatistics />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Content;
